var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showHeader)?_c('v-header',{staticClass:"header"}):_vm._e(),(_vm.showHeader)?_c('v-headers',{staticClass:"headers"}):_vm._e(),_c('router-view'),_c('v-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }